import { useState } from "react";
import { motion } from "framer-motion";
import { PiRows, PiList } from "react-icons/pi";
import CategoryItem from "./CategoryItem";

export interface CategoryGridItem {
  id: string;
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  className?: string;
}

interface CategoryGridProps {
  title: string;
  items: CategoryGridItem[];
  onItemClick: (item: CategoryGridItem) => void;
  showToggle?: boolean;
}

const CategoryGrid = ({ 
  title, 
  items, 
  onItemClick, 
  showToggle = true 
}: CategoryGridProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const shouldShowToggle = showToggle && items.length > 2;

  return (
    <div className="w-full tour-category-grid">
      <div className="flex items-center justify-between mb-3">
        <p className="font-semibold text-sm text-black">
          {title}
        </p>
        {shouldShowToggle && (
          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsExpanded(!isExpanded)}
            className="p-2 bg-zinc-100 hover:bg-zinc-200 rounded-lg transition-colors tour-category-grid-toggle"
          >
            {isExpanded ? (
              <PiRows className="h-4 w-4 text-zinc-600" />
            ) : (
              <PiList className="h-4 w-4 text-zinc-600" />
            )}
          </motion.button>
        )}
      </div>
      
      {isExpanded ? (
        <div className="grid grid-cols-3 gap-3">
          {items.map((item) => (
            <CategoryItem
              key={item.id}
              title={item.title}
              subtitle={item.subtitle}
              icon={item.icon}
              onClick={() => onItemClick(item)}
              className={item.className}
            />
          ))}
        </div>
      ) : (
        <div className="flex gap-3 overflow-x-auto pt-1 pb-2">
          {items.map((item) => (
            <CategoryItem
              key={item.id}
              title={item.title}
              subtitle={item.subtitle}
              icon={item.icon}
              onClick={() => onItemClick(item)}
              className={item.className}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryGrid;
